var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('Pagetitle'),_c('Texttitle',{attrs:{"textTitleServices":_vm.texttitle}}),_c('Doweworks',{attrs:{"commonServices":_vm.services,"servicesSectionClass":'web'}}),_c('ThatsWhy'),_c('OurApproach'),_c('Whychooseus',{attrs:{"commonWhyChoose":_vm.whyChooseUsServices,"whyChooseClass":'web'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }